import { MembershipType, WorkSector } from './member';

export enum EmailCampaignStatus {
  Draft = 1,
  Sending = 2,
  Completed = 3,
  Failed = 4,
  Cancelled = 5,
}

export enum EmailRecipientStatus {
  Pending = 1,
  Sent = 2,
  Failed = 3,
  Cancelled = 4,
}

export { MembershipType, WorkSector };

export interface MemberFilterParams {
  page?: number;
  pageSize?: number;
  search?: string;
  membershipType?: MembershipType;
  workSector?: WorkSector;
  registrationYearFrom?: number;
  registrationYearTo?: number;
  isGraduateStudent?: boolean;
  isRetired?: boolean;
  isVolunteer?: boolean;
  isHonoraryMember?: boolean;
  isActive?: boolean;
  mainCommittee?: string;
  committeeIsMain?: boolean;
  additionalCommittees?: string[];
  residentialCity?: string;
  residentialCountry?: string;
  professionalCity?: string;
  /** Explicit member selection (IDs). */
  memberIds?: string[];
}

export interface EmailCampaign {
  id: string;
  name: string;
  /** Greek subject (default language). */
  subject: string;
  /** Greek body (default language). */
  body: string;
  subjectEn: string;
  bodyEn: string;
  status: EmailCampaignStatus;
  recipientCount: number;
  createdBy: string;
  createdByName?: string;
  templateId?: string;
  templateName?: string;
  createdAt: string;
  sentAt?: string;
  completedAt?: string;
  errorMessage?: string;
  sentCount: number;
  failedCount: number;
}

export interface CreateEmailCampaign {
  name: string;
  /** Greek subject (default language). */
  subject: string;
  /** Greek body (default language). */
  body: string;
  subjectEn: string;
  bodyEn: string;
  memberFilter?: MemberFilterParams;
  templateId?: string;
}

export interface EmailTemplate {
  id: string;
  name: string;
  subject: string;
  body: string;
  subjectEn: string;
  bodyEn: string;
  variables?: string[];
  createdBy: string;
  createdByName?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateEmailTemplate {
  name: string;
  subject: string;
  body: string;
  subjectEn: string;
  bodyEn: string;
  variables?: string[];
}

export interface EmailSendResult {
  totalSent: number;
  totalFailed: number;
  totalPending: number;
  errors: string[];
  estimatedCompletionTime?: string;
  status: EmailCampaignStatus;
}

export interface EmailRecipient {
  id: string;
  campaignId: string;
  memberId: string;
  email: string;
  memberFirstName?: string;
  memberLastName?: string;
  communicationLanguage?: number;
  status: EmailRecipientStatus;
  sentAt?: string;
  errorMessage?: string;
}

export interface PagedEmailCampaigns {
  items: EmailCampaign[];
  total: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

export interface PagedEmailRecipients {
  items: EmailRecipient[];
  total: number;
  page: number;
  pageSize: number;
  totalPages: number;
}
